/* 🤖 this file was generated by svg-to-ts */
export const matIconCrop: {
  name: 'crop';
  data: string;
} = {
  name: 'crop',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z"/></svg>`
};
